import React from 'react';
import { Switch } from '@mui/material';

const styles = {
  root: {
    width: 42,
    height: 26,
    padding: 0,
    margin: (theme) => theme.spacing(1),
  },
  switchBase: {
    padding: 1,
    '&$checked': {
      transform: 'translateX(16px)',
      color: (theme) => theme.palette.common.white,
      '& + $track': {
        backgroundColor: '#097152',
        opacity: 1,
        border: 'none',
      },
      '&$disabled': {
        color: '#bdbdbd',
        '& + $track': {
          backgroundColor: '#79a597',
        },
      },
    },
    '&$focusVisible $thumb': {
      color: '#52d869',
      border: '6px solid #fff',
    },
  },
  thumb: {
    width: 24,
    height: 24,
  },
  track: {
    borderRadius: 26 / 2,
    border: (theme) => `1px solid ${theme.palette.grey[400]}`,
    backgroundColor: (theme) => theme.palette.grey[50],
    opacity: 1,
    transition: (theme) => theme.transitions.create(['background-color', 'border']),
  },
  checked: {},
  disabled: {},
  focusVisible: {},
}

export default function AmploSwitch(props) {
  return (
    <Switch
      focusVisiblesx={styles.focusVisible}
      disableRipple
      styles={{
        root: styles.root,
        switchBase: styles.switchBase,
        thumb: styles.thumb,
        track: styles.track,
        checked: styles.checked,
        disabled: styles.disabled,
      }}
      {...props}
    />
  );
}
